/** Both sides use the same project so Cognito sub links browser and API events. */
export function getPostHogConfig() {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;
  return key && host ? { key, host } : null;
}
